import { render, staticRenderFns } from "./HistogramProgram.vue?vue&type=template&id=6c3278fd&"
import script from "./HistogramProgram.vue?vue&type=script&lang=js&"
export * from "./HistogramProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports